const breakpoints = {
  xs: "320",
  sm: "720",
  md: "1024",
  l: "1600",
  portrait: "orientation: portrait",
}

export default breakpoints
